import options from './feedback-form.component';

export default {
    selector: 'dtFeedbackForm',
    options
};



// WEBPACK FOOTER //
// ./app/common/help-menu/feedback-form/index.js